/* */
import React, { Fragment, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  onScrollEnd: PropTypes.func,
  marginTop: PropTypes.number,
  classNameDetector: PropTypes.string,
  styleDetector: PropTypes.object,
};

const ScrollWrapper = ({
  children,
  onScrollEnd,
  marginTop = 0,
  classNameDetector = '',
  styleDetector = {},
}) => {
  //! State
  const { ref, inView } = useInView();

  //! Function
  useEffect(() => {
    if (inView) {
      onScrollEnd && onScrollEnd();
    }
  }, [inView]);

  //! Render
  return (
    <Fragment>
      {children}
      <div
        ref={ref}
        className={classNameDetector}
        style={{
          display: 'flex',
          visibility: 'hidden',
          height: '1px',
          transform: `translateY(${marginTop}px)`,
          zIndex: -2,
          ...(styleDetector || {}),
        }}
      />
    </Fragment>
  );
};

ScrollWrapper.propTypes = propTypes;
export default ScrollWrapper;
